import Link from "next/link";

export function LoginRegisterToggle({ active }: { active: "login" | "register" }) {
  const buttons = [
    { label: "Log in", href: "/auth/login", disabled: active === "login" },
    {
      label: "Register",
      href: "/auth/register",
      disabled: active === "register",
    },
  ];

  return (
    <div className="flex w-full bg-info rounded-md my-8 py-1 mx-auto gap-x-2">
      {buttons.map((button, index) => (
        <Link key={index} href={button.href} className="w-1/2 px-1">
          <button
            className={`w-full rounded-md p-1 font-bold ${button.disabled ? "bg-white" : ""}`}
            disabled={button.disabled}
          >
            {button.label}
          </button>
        </Link>
      ))}
    </div>
  );
}
